/* eslint-disable no-underscore-dangle */
import ReactDOM from 'react-dom';

type Instance =
  | (Element & {
      nodeType?: number;
      _reactInternals?: {
        child?: {
          stateNode?: Element | Text;
        };
      };
    })
  | null;

// Extend ReactDOM types to include findDOMNode
declare module 'react-dom' {
  export function findDOMNode(instance: Instance): Element | Text | null;
}

// Polyfill for findDOMNode which was removed in React 19
// This is needed for compatibility with @livechat/design-system-react-components
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (instance: Instance) => {
    if (instance == null) {
      return null;
    }

    // If it's already a DOM node, return it
    if (instance.nodeType === 1) {
      return instance;
    }

    // For React components, try to get the underlying DOM node
    // This is a simplified version that works for most cases
    if (instance._reactInternals?.child?.stateNode) {
      return instance._reactInternals.child.stateNode;
    }

    // Fallback: return null instead of throwing
    return null;
  };
}
